import {
  LOADER_SET,
  NOTIFY_SET,
  RESET_REDUX,
  USER_SET,
  TICKER_SET,
  CPTY_SET,
  REFRESH_SET,
  REFRESH_LOAN,
  REFRESH_BORROW,
  REFRESH_SECMASTER,
  REFRESH_CPTY,
} from "./actions";

export const DEFAULT_USER = {
  id: null,
  token: null,
  userName:null
};

export const user = (state = DEFAULT_USER, action) => {
  switch (action.type) {
    case USER_SET:
      return action.state;
    case RESET_REDUX: {
      const userData = DEFAULT_USER;
      return userData;
    }

    default:
      return state;
  }
};

export const ticker = (state = {}, action) => {
  switch (action.type) {
    case TICKER_SET:
      return action.state;
    default:
      return state;
  }
};
export const cptyData = (state = {}, action) => {
  switch (action.type) {
    case CPTY_SET:
      return action.state;
    default:
      return state;
  }
};

export const refresh = (state = null, action) => {
  switch (action.type) {
    case REFRESH_SET:
      return action.state;
      default:
        return state;
  }
}

export const refreshLoan = (state = null, action) => {
  switch (action.type) {
    case REFRESH_LOAN:
      return action.state;
      default:
        return state;
  }
}
export const refreshBorrow = (state = null, action) => {
  switch (action.type) {
    case REFRESH_BORROW:
      return action.state;
      default:
        return state;
  }
}
export const refreshSecMaster = (state = null, action) => {
  switch (action.type) {
    case REFRESH_SECMASTER:
      return action.state;
      default:
        return state;
  }
}
export const refreshCpty = (state = null, action) => {
  switch (action.type) {
    case REFRESH_CPTY:
      return action.state;
      default:
        return state;
  }
}


export const loader = (state = false, action) => {
  switch (action.type) {
    case LOADER_SET:
      return action.state;

    default:
      return state;
  }
};

export const notify = (state = {}, action) => {
  switch (action.type) {
    case NOTIFY_SET:
      return action.state;

    default:
      return state;
  }
};
